<template>
  <loading-overlay :active="isLoading" :is-full-page="true" :width="128" :height="128" loader="spinner" color="rgb(var(--color-active-hsl-128))" background-color="rgb(var(--color-b-back))" />
  <SrcBackgroundScroll @scrolled="isShrunk = $event">
    <HeadlineSubScroll 
        :title="$t('settings.ocppdlm')" 
        target="/Settings" 
        :hassubline="!isShrunk"
        :hasmenu="false"
        :isShrunk="isShrunk"
        >
          <template #icon>
            <IconOcpp             
              class="transition-all duration-300"
              :class="isShrunk ? 'w-8 h-8' : 'w-12 h-12'"/>
          </template>
          <template #subline>
            {{ $t('settings.settingsfor',{wallbox:this.decodeHtml(this.$store.state.WbName)} ) }}
          </template>
    </HeadlineSubScroll>

    <ConfirmLeaveModal
      v-model:show="showLeaveDialog"
      :pendingNavigation="this.leaveDialog"
    />

    <SettingsHeader :admin="this.$store.state.Role=='admin'">
      {{ this.decodeHtml(this.$store.state.WbName) }}
    </SettingsHeader>

    <SettingsBody>
      <template v-slot:formgrid>
          <div class="form-group mb-2 sm:col-span-2">
              <TextfieldWithLabel
                :label="$t('common.notice')"
                :text="$t('setocppdlm.notice')"
              />
          </div>
          <div class="mt-2 mb-2">
            <ToggleWithLabel 
              v-model="ocppmode"
              :label="$t('setocppdlm.ocpponoff')"
              :ontext="$t('common.on')"
              :offtext="$t('common.off')"
              @update:modelValue ="onChange"
            />
          </div>
          <div class="form-group mb-2">
            <label class="font-medium text-sm text-skin-b-list-mute" for="ActualOCPPstatus">{{ $t('setocpp.status') }}</label>
            <input disabled v-model="occpstatustxt" type="text" class="form-control
              mt-1 block w-full px-3 py-2 rounded-lg 
              font-semibold text-lg disabled:text-skin-b-list-mute
              border-2 border-skin-b-list-bord" 
              :class="{ 'bg-skin-b-list-head': occpstatus==''||occpstatus=='disabled',
                        'bg-orange-100': occpstatus=='connecting'||occpstatus=='disconnected',
                        'bg-green-100': occpstatus=='connected',
                        'bg-red-100': occpstatus=='error_config'||occpstatus=='reboot_req' }" 
              name="ActualOCPPstatus" id="ActualOCPPstatus" ref="ActualOCPPstatus"
              aria-describedby="ActualOCPPstatus" :placeholder="$t('setocpp.status')">
          </div>        
          
          <div class="form-group mb-2">
            <InputLabelError 
                v-model="ocpp_cpid"
                :disabled="!ocppmode"
                :label="$t('setocpp.chargepointid')"
                :placeholder="$t('setocpp.chargepointidph')"
                @update:modelValue ="onChange"
              />
          </div>

          <div class="form-group mb-2 sm:col-span-2">
            <InputLabelError 
                v-model="ocpp_url"
                :disabled="!ocppmode"
                :label="$t('setocpp.url')"
                placeholder="ocpp.example.com"
                @update:modelValue ="onChange"
              />
          </div>

          <div class="form-group mb-2">

            <SelectWithLabelIcon
                v-model="ocpp_seclevel"
                :disabled="!ocppmode"
                :label="$t('setocpp.seclevel')"
                 @update:modelValue ="onChange"
             >
              <template v-slot:options>
                <option value="0" selected>{{ $t('setocpp.seclevel0') }}</option>
                <option value="1">{{ $t('setocpp.seclevel1') }}</option>
                <option value="2">{{ $t('setocpp.seclevel2') }}</option>
              </template>
            </SelectWithLabelIcon>
          </div>

          <div class="form-group mb-2">
            <InputLabelError 
                v-if="ocpp_seclevel>0"
                v-model="ocpp_seckey"
                :disabled="!ocppmode"
                :label="$t('setocpp.secpassword')"
                :placeholder="$t('setocpp.secpasswordph')"
                @update:modelValue ="onChange"
            />
          </div>

        </template>
        <template v-slot:formbottom>
          <div class="w-full mt-6">
            <ActionButton :disabled="!isDirty" @click="saveOcpp()">
              {{ $t('common.save') }}
            </ActionButton>
          </div>

        <div v-if="ocppsaved||occpstatus=='reboot_req'" class="grid gap-4 sm:grid-cols-2">
          <TextfieldWithLabel
              class="mt-4"
              :text="$t('setocpp.savemessage')"
            />
          <div class="mt-4 w-full text-right">
            <ActionButton @click="restartmodal=true" color="red" :wfull="false">
              {{ $t('common.restartwallbox') }}
            </ActionButton>
          </div>          
        </div>

        <div v-if="restartmodal" class="fixed flex justify-center items-center top-0 left-0 right-0 z-50 bg-black/20 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
              <div class="relative w-full max-w-md max-h-full">
                  <div class="relative bg-white rounded-lg shadow">
                      <button @click.prevent="submitForm" @click="restartmodal=false" type="button" class="absolute top-3 right-2.5 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center">
                          <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
                          <span class="sr-only">Close modal</span>
                      </button>
                      <div class="p-6 text-center">
                          <svg aria-hidden="true" class="mx-auto mb-4 w-14 h-14" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                          <h3 class="mb-5 text-lg font-semibold text-gray-500">
                            {{ $t('common.restartquestion') }}</h3>
                            <ActionButton @click="restartmodal=false;restartBox();countermodal=true;restarttimer();" color="red" :wfull="false" :margin="true">
                              {{ $t('common.restartconfirm') }}
                            </ActionButton>
                            <ActionButton @click="restartmodal=false" :wfull="false">
                              {{ $t('common.cancel') }}
                            </ActionButton>
                      </div>
                  </div>
              </div>
          </div>
          <div v-if="countermodal" class="fixed flex justify-center items-center top-0 left-0 right-0 z-50 bg-black/20 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full">
              <div class="relative w-full max-w-md max-h-full">
                  <div class="relative bg-white rounded-lg shadow">
                      <div class="p-6 text-center">
                        <h1 class="mb-5 text-5xl font-semibold">
                            {{counter}} s</h1>
                        <h3 class="mb-5 text-lg font-semibold">
                          {{ $t('common.restartnotice') }}</h3>
                      </div>
                  </div>
              </div>
          </div>


        </template>
    </SettingsBody>
  </SrcBackgroundScroll>
</template>

<script>
import SrcBackgroundScroll from './sources/SrcBackgroundScroll.vue'
import HeadlineSubScroll from './elements/HeadlineSubScroll.vue'
import IconOcpp from './icons/IconOcpp.vue'
import SettingsHeader from './elements/SettingsHeader.vue'
import SettingsBody from './elements/SettingsBody.vue'
import ActionButton from './elements/ActionButton.vue'
import InputLabelError from './elements/InputLabelError.vue'
import TextfieldWithLabel from './elements/TextfieldWithLabel.vue'
import ToggleWithLabel from './elements/ToggleWithLabel.vue'
import SelectWithLabelIcon from './elements/SelectWithLabelIcon.vue'
import ConfirmLeaveModal from './elements/ConfirmLeaveModal.vue'
import { useI18n } from 'vue-i18n'

export default {
  setup () {
      const { t,d,n } = useI18n()
      return { t,d,n }
    },  
  components: {
      SrcBackgroundScroll, HeadlineSubScroll, IconOcpp,
      SettingsHeader, SettingsBody, ActionButton,
      InputLabelError, TextfieldWithLabel, ToggleWithLabel, SelectWithLabelIcon, ConfirmLeaveModal
    }, 
  data() {
    return {
          isLoading: false,
          saveto: this.$store.state.WbId,
          restartmodal: false,
          countermodal: false,
          counter: 120,
          ocppmode: false,
          ocppsaved: false,
          occpstatus: '',
          occpstatustxt: '',
          occp_onoff: 0,
          ocpp_cpid: '',
          ocpp_url: '',
          ocpp_seclevel: 0, // 1,2,3
          ocpp_seckey: '',
          ocpp_serialnumber: '',
          ocpp_model: '',
          ocpp_vendor: 'Kathrein',
          ocpp_firmware: '',
          client_info: [],
          clients_list: [],
          client_swversion: [],
          isShrunk: false,

          isDirty:false,
          showLeaveDialog:false

    }
  },
  beforeRouteLeave(to, from, next) {

    if (this.isDirty || this.editmode) {
      this.showLeaveDialog = true;
      this.pendingNavigation = next;    
    } else {
      next();
    }
  },
  computed: {
  },
  methods: {
    onChange() {this.isDirty = true;},
    leaveDialog(){this.pendingNavigation();},
    restarttimer() {
        this.interval = setInterval(() => {
          if (this.counter === 0) {
            clearInterval(this.interval);
            this.$router.push({path: '/'});               
          } else {
            this.counter--
          }             
        }, 1000)
    },
    decodeHtml: function(html) {
      let txt = document.createElement("textarea");
      txt.innerHTML = html;
      return txt.value;
      },
    saveOcpp() {
      if(this.ocppmode)
        this.occp_onoff=1;
      else
        this.occp_onoff=0;

      let eu_ocpp_url = encodeURIComponent(this.ocpp_url);
      let eu_ocpp_cpid = encodeURIComponent(this.ocpp_cpid);
      let eu_ocpp_seckey = encodeURIComponent(this.ocpp_seckey);    
      this.axios
      .get('wallbox/settings.php?action=sync_ocpp_dlm&client='+this.saveto+'&active='+this.occp_onoff+'&uri='+eu_ocpp_url+'&chargepoint='+eu_ocpp_cpid+'&security='+this.ocpp_seclevel+'&pass='+eu_ocpp_seckey+'&user='+this.$store.state.token)
      .then((response) => {        
                  if(response.data.status=='ok'){
                    this.ocppsaved = true;
                    console.log('ocpp gespeichert');
                  }else{
                    console.log('fehler save ocpp');                   
                  }
                })
                .catch((errors) => {
                    console.log(errors); // Errors
                });
      this.isDirty=false;
    },
    restartBox(){
      this.axios
              .get('wallbox/client.php?action=reboot&user='+this.$store.state.token+'&id='+this.saveto)
              .then((response) => {         
                          if(response.data.status=='ok'){
                            console.log('Restart der Wallbox');
                          }else{
                            console.log('Error send reboot command');                   
                          }
                        })
              .catch((errors) => {
                console.log(errors); // Errors
              });
    }
  },
  created() {  
      this.isLoading = true;
      let client_OcppUrl = 'wallbox/info.php?action=get_ocpp_dlm&user='+this.$store.state.token+'&client='+this.$store.state.WbId;
      let client_statusUrl = 'wallbox/info.php?action=get_status&user='+this.$store.state.token+'&client='+this.$store.state.WbId;
      let client_infoUrl = 'wallbox/client.php?action=client_info&user='+this.$store.state.token+'&id='+this.$store.state.WbId; // .article nicht über client-ID auslesbar
      //let clients_listUrl = 'wallbox/client.php?action=get_clients&user='+this.$store.state.token;
      let client_swversionUrl = 'wallbox/info.php?action=get_version&user='+this.$store.state.token+'&client='+this.$store.state.WbId;

      const requestclient_Ocpp = this.axios.get(client_OcppUrl);
      const requestclient_status = this.axios.get(client_statusUrl);
      const requestclient_info = this.axios.get(client_infoUrl);      
      //const requestclients_list = this.axios.get(clients_listUrl);
      const requestclient_swversion = this.axios.get(client_swversionUrl);
      this.axios
          .all([requestclient_Ocpp, requestclient_status, requestclient_info, requestclient_swversion])
          .then(
              this.axios.spread((...responses) => {
                  const responseclient_Ocpp = responses[0];
                  const responseclient_status = responses[1];
                  const responseclient_info = responses[2]; 
                  //const responseclients_list = responses[3];
                  const responseclient_swversion = responses[3];

                  if(responseclient_Ocpp.data.status=='token'){
                        this.$router.push({path: '/'});             
                    }else if(responseclient_Ocpp.data.status=='ok'){
                    this.occp_onoff = responseclient_Ocpp.data.tbl_ocpp_dlm.ocppEnabled;  
                    this.ocpp_cpid = responseclient_Ocpp.data.tbl_ocpp_dlm.chargePointId;
                    this.ocpp_url = responseclient_Ocpp.data.tbl_ocpp_dlm.uri;
                    this.ocpp_seclevel = responseclient_Ocpp.data.tbl_ocpp_dlm.security;
                    this.ocpp_seckey = responseclient_Ocpp.data.tbl_ocpp_dlm.password;
                    if(this.occp_onoff==1)
                      this.ocppmode=true;
                    else
                      this.ocppmode=false;                                       
                  }else{
                    console.log('Error get OCPP Table');
                  }

                  if(responseclient_status.data.status=='token'){
                        this.$router.push({path: '/'});             
                  }else if(responseclient_status.data.status=='ok'){
                    this.occpstatus = responseclient_status.data.tbl_status.ocppDlmStatus;
                      if(responseclient_status.data.tbl_status.ocppDlmStatus=='disabled')
                        this.occpstatustxt = this.$t('setocpp.disabled');
                      if(responseclient_status.data.tbl_status.ocppDlmStatus=='connecting')
                        this.occpstatustxt = this.$t('setocpp.connecting');
                      if(responseclient_status.data.tbl_status.ocppDlmStatus=='connected')
                        this.occpstatustxt = this.$t('setocpp.connected');
                      if(responseclient_status.data.tbl_status.ocppDlmStatus=='disconnected')
                        this.occpstatustxt = this.$t('setocpp.disconnected');
                      if(responseclient_status.data.tbl_status.ocppDlmStatus=='error_config')
                        this.occpstatustxt = this.$t('setocpp.error_config');
                      if(responseclient_status.data.tbl_status.ocppDlmStatus=='reboot_req')
                        this.occpstatustxt = this.$t('setocpp.reboot_req');   
                  }else{
                    console.log('Error get Client Status Table');
                  }

                  if(responseclient_info.data.status=='token'){
                      this.$router.push({path: '/'});             
                  }else if(responseclient_info.data.status=='ok'){
                    this.ocpp_model = responseclient_info.data.tbl_clientsettings.article;
                    this.ocpp_serialnumber = responseclient_info.data.tbl_clientsettings.serial;          
                  }else{
                    console.log('Error get Client Info Table');
                  }
                  
                  if(responseclient_swversion.data.status=='token'){
                        this.$router.push({path: '/'});             
                  }else if(responseclient_swversion.data.status=='ok'){
                    this.client_swversion = responseclient_swversion.data.tbl_version;
                    this.ocpp_firmware = this.client_swversion.linuxVersion;               
                  }else{
                    console.log('Error get SW Version Table');
                  }
              this.isLoading = false;
              })
          )
          .catch((errors) => {
              this.isLoading = false;
              console.error(errors);
          });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="@vueform/toggle/themes/default.css"></style>
<style scoped>
</style>
